import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type ChairLayout = 'modern' | 'classic';

export const CHAIR_LAYOUTS = {
  MODERN: 'modern' as ChairLayout,
  CLASSIC: 'classic' as ChairLayout,
};

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private static readonly STORAGE_KEY = 'jems3-tpc-chair-layout';
  private static readonly WIDE_STORAGE_KEY = 'jems3-tpc-chair-wide-mode';

  private readonly _layout$: BehaviorSubject<ChairLayout>;
  readonly layout$: Observable<ChairLayout>;

  private readonly _wideMode$: BehaviorSubject<boolean>;
  readonly wideMode$: Observable<boolean>;

  constructor() {
    const stored = localStorage.getItem(LayoutService.STORAGE_KEY) as ChairLayout | null;
    const initial: ChairLayout = stored === CHAIR_LAYOUTS.CLASSIC ? CHAIR_LAYOUTS.CLASSIC : CHAIR_LAYOUTS.MODERN;
    this._layout$ = new BehaviorSubject<ChairLayout>(initial);
    this.layout$ = this._layout$.asObservable();

    const wideStored = localStorage.getItem(LayoutService.WIDE_STORAGE_KEY);
    this._wideMode$ = new BehaviorSubject<boolean>(wideStored === '1');
    this.wideMode$ = this._wideMode$.asObservable();
  }

  getLayout(): ChairLayout {
    return this._layout$.value;
  }

  setLayout(layout: ChairLayout): void {
    if (layout !== CHAIR_LAYOUTS.MODERN && layout !== CHAIR_LAYOUTS.CLASSIC) return;
    if (this._layout$.value === layout) return;
    localStorage.setItem(LayoutService.STORAGE_KEY, layout);
    this._layout$.next(layout);
  }

  getWideMode(): boolean {
    return this._wideMode$.value;
  }

  setWideMode(active: boolean): void {
    if (this._wideMode$.value === active) return;
    localStorage.setItem(LayoutService.WIDE_STORAGE_KEY, active ? '1' : '0');
    this._wideMode$.next(active);
  }

  toggleWideMode(): void {
    this.setWideMode(!this._wideMode$.value);
  }
}
